import { render, staticRenderFns } from "./my-flexspend.vue?vue&type=template&id=138c2bb2&"
import script from "./my-flexspend.vue?vue&type=script&lang=tsx&"
export * from "./my-flexspend.vue?vue&type=script&lang=tsx&"
import style0 from "./my-flexspend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports